import React from 'react'
import { Icon } from '@pff-consumer/web-ui/components/icon/icon'
import { SVGGroup } from '@pff-consumer/utils/lib/svg/svg-group'
import { CarouselArrowProps } from './carousel-arrow.props'
import { useStyles } from './carousel-arrow.styles'

export const CarouselArrow = (props: CarouselArrowProps) => {
  const { onClickHandler = () => {}, label = '' } = props
  const styles = useStyles(props)

  const arrowClickHandler = (e: React.KeyboardEvent) => {
    e.stopPropagation()
    if (e.key === 'Enter' || e.key === ' ') {
      onClickHandler()
    }
  }

  return (
    <div className={styles.arrowContainer}>
      <div
        className={styles.arrowWrapperCircle}
        onClick={onClickHandler}
        onKeyDown={arrowClickHandler}
        title={label}
        role='button'
        tabIndex={0}
      >
        <Icon
          name='chevron-gray'
          testID='arrow-icon'
          group={SVGGroup.Icons}
          width={20}
          height={20}
          className={styles.arrowIcon}
        />
      </div>
    </div>
  )
}
